import { useEffect, useState } from 'react';

/**
 * Hook que devuelve el estado actual de conexión a Internet.
 *
 * Basado en `navigator.onLine` + eventos `online`/`offline` del browser.
 * Detecta cambios en tiempo real sin polling.
 *
 * Caveat: navigator.onLine es una pista del SO, no una prueba real de
 * que la app puede llegar al backend. Para eso (ping de salud) hacemos
 * un check explícito en `useConectividadBackend` si más adelante hace falta.
 */
export function useEstadoConexion(): boolean {
  const [online, setOnline] = useState<boolean>(
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  );

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return online;
}
